import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

import { CopyRightItem, FooterContent, FooterItem, Wrapper } from "./styles";
import footerConfig, { FooterConfigType } from "./opco-defaults/index";

import getOpco from "utils/getOpco";
import { isFeatureActive } from "utils/getFeature";

const opcoFooterConfig: FooterConfigType = footerConfig[getOpco()] || footerConfig.gb;

const isFooterVisible = (pathname: string) => {
  const isSpecialPage = pathname === "/" || pathname === "cookie-preferences" || pathname === "/myaccount";
  const isOfferPage =
    (pathname.includes("/offer/") || pathname.includes("/multiplanoffer/")) &&
    !pathname.includes("cancellation") &&
    !pathname.includes("pre-setup-form");

  const isFooterAlwaysVisible = isFeatureActive("Footer visible on all pages");
  const isNotElligible = pathname === "/not-eligible-user";

  return (isSpecialPage || isOfferPage || isFooterAlwaysVisible) && !isNotElligible;
};

const Footer = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const isVisible = useMemo(() => isFooterVisible(pathname), [pathname]);
  const CopyRightText =
    isFeatureActive("Enabled default theme") || isFeatureActive("Enabled CZ theme")
      ? `© Vodafone ${new Date().getFullYear()}`
      : `© Lowi ${new Date().getFullYear()}`;

  const footerItems = [
    {
      key: "privacy-policy",
      label: t("Privacy policy"),
    },
    {
      key: "cookie-preferences",
      label: t("Cookie Preferences"),
    },
    {
      key: "terms-and-conditions",
      label: t("Subscription+ terms & conditions"),
    },
    {
      key: "accessibility",
      label: t("Accessibility"),
    },
    { key: "help-and-support", label: t("Help & support") },
    {
      key: "imprint",
      label: t("Imprint"),
    },
    {
      key: "terminate-contract",
      label: t("Terminate contract"),
    },
  ];

  return isVisible ? (
    <Wrapper data-testid="footer">
      <FooterContent>
        {footerItems.map((item) => {
          const opcoFooterItem = opcoFooterConfig[item.key as keyof typeof opcoFooterConfig];
          if (opcoFooterItem)
            return (
              <FooterItem key={item.key} data-testid={`footer-${item.key}`}>
                <Link to={opcoFooterItem}>{item.label}</Link>
              </FooterItem>
            );
        })}
      </FooterContent>
      <CopyRightItem data-testid={"footer-copyright"}>{CopyRightText}</CopyRightItem>
    </Wrapper>
  ) : null;
};

export default React.memo(Footer);
